import { FC } from "react";
import { useQueryParams, NumberParam } from "use-query-params";

import { copy } from "shared/assets";
import { CalendarDate } from "shared/assets/icons";
import { Action } from "shared/components";

interface TodayActionProps {
  disabled?: boolean;
}

export const TodayAction: FC<TodayActionProps> = ({ disabled }) => {
  const [, setDate] = useQueryParams({
    month: NumberParam,
    year: NumberParam,
  });

  const handleClick = () => {
    const today = new Date();
    setDate({
      month: today.getMonth(),
      year: today.getFullYear(),
    });
  };

  return (
    <Action
      label={copy.calendar.today}
      icon={CalendarDate}
      handleClick={handleClick}
      disabled={disabled}
    />
  );
};
